<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import {ref} from "vue";
import moment from "moment";

export default {
  name: "MobileMonitoringList",
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      baseUrl: process.env.VUE_APP_BASE_API_URL + 'api/v2/info/file/',
      initiative_id: null,
      showEditTemplateModal: false,
      selectedInitiativeId: null,
      page: 1,
      limit: 10,
      count: 0,
      form: {
        reject_reason: null
      },
      rules: {
        reject_reason: [{required: true, message: "Majburiy maydon", trigger: "change"}],
      }
    }
  },

  methods: {
    handleCurrentChange() {
      this.getMobileMonitoringList()
    },
    closeEditTemplateModal() {
      this.form.reject_reason = null;
    },
    onClickRejectMonitoring(initiativeId) {
      this.selectedInitiativeId = initiativeId
      this.showEditTemplateModal = true

    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/initiatives/mobile-monitoring/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getMobileMonitoringList();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    getMobileMonitoringList() {
      this.loading = true;
      this.$http
          .get("/api/v1/initiatives/mobile-monitoring", {
            params: {
              offset: (this.page - 1) * this.limit,
              limit: this.limit,
              initiative_id: this.initiative_id
            }
          })
          .then(({data}) => {
            this.tableData = data.monitorings;
            this.count = data.count;
          })
          .catch(({response}) => {
            ElNotification.error({
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onSubmitReject() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http
              .post(`/api/v1/initiatives/mobile-monitoring/${this.selectedInitiativeId}/reject`, this.form)
              .then(() => {
                ElNotification.success({
                  message: "Bekor qilindi!",
                });
                this.showEditTemplateModal = false;
                this.getMobileMonitoringList()
              })
              .catch(({response}) => {
                ElNotification.error({
                  message:
                      response.data.message ||
                      "Ma'lumot saqlashda xatolik sodir bo'ldi!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.initiative) {
      this.initiative_id = this.$route.params.initiative;
      this.getMobileMonitoringList()
    }
  }
}
</script>

<template>
  <div class="mobile-monitoring-list">
    <div class="header">
      <el-button @click="$router.push({name:'Initiatives'})">
        <img src="@/assets/images/icons/arrow-left.svg" alt="<--"/>
        Ortga
      </el-button>
      <el-button
          v-if="$store.state.role === 'moderator'"
          type="primary"
          @click="$router.push({ name: 'MobileMonitoringFormAdd',params:{initiative:initiative_id} })"
      >Qo'shish
      </el-button>
    </div>
    <el-table :data="tableData" border height="calc(100vh - 235px)">
      <el-table-column label="T/r" type="index" align="center"/>
      <el-table-column prop="moderator_fullname" min-width="140" label="Moderator"/>
      <el-table-column prop="created_at" min-width="120" label="Sana">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format('DD.MM.YYYY') }}
        </template>
      </el-table-column>
      <el-table-column prop="address_title" min-width="140" label="Manzil"/>
      <el-table-column prop="comment" min-width="80" label="Izoh">
        <template v-slot="scope">
          <el-popover
              placement="top-start"
              title="Izoh"
              :width="200"
              trigger="hover"
              :content="scope.row.comment"
          >
            <template #reference>
              <span>{{ scope.row.comment.substring(0, 10) + '...' }}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column style="z-index: 999" prop="icon" label="Rasmlar" min-width="80" align="center">
        <template v-slot="scope">
          <el-image
              style="width: 50px; height: 50px"
              :src="baseUrl+scope.row.images[0]"
              :zoom-rate="1.2"
              :preview-src-list="scope.row.images.map(hash=>baseUrl+hash)"
              fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column v-if="$store.state.role === 'admin'"
                       fixed="right"
                       label=""
                       width="220"
                       align="center">
        <template #default="scope">
          <el-button
              type="warning"
              size="small"
              @click="onClickRejectMonitoring(scope.row.id)"
          >
            Bekor qilish
          </el-button>
          <el-button
              type="primary"
              size="small"
              @click="$router.push({
                name: 'MobileMonitoringFormEdit',
                params: { id: scope.row.id },
              })
            "
          >
            <img height="15" src="@/assets/images/icons/edit.svg" alt="action"/>
          </el-button>
          <el-button
              type="danger"
              size="small"
              @click="onClickDelete(scope.row.id)"
          >
            <img height="15" src="@/assets/images/icons/delete.svg" alt="action"/>
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="count"
          v-model:page-size="limit"
          v-model:current-page="page"
      />
    </div>
  </div>
  <el-dialog
      v-model="showEditTemplateModal"
      title="Bekor qilish sababi"
      @close="closeEditTemplateModal"
      style="max-width: 600px"
      align-center
  >
    <el-form
        ref="form"
        label-position="top"
        :model="form"
        style="width: 500px"
        :rules="rules"
        status-icon
        hide-required-asterisk
    >
      <el-form-item label="" prop="reject_reason">
        <el-input
            v-model="form.reject_reason"
            type="textarea"
            :rows="5"
            placeholder="Kiriting"
        />
      </el-form-item>
    </el-form>
    <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeEditTemplateModal">Bekor qilish</el-button>
          <el-button type="primary" @click="onSubmitReject">
            Saqlash
          </el-button>
        </span>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.el-button--primary {
  text-decoration: none;
}

:deep(.el-table) {
  .el-table__cell {
    position: inherit;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: right;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
